import { connect } from 'react-redux';
import ReportDataTable from '../components/reports/UserReport';

const mapStateToProps = (state, ownProps) => ({
  data: state.reports.userReport,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportDataTable);
